/* eslint-disable react/forbid-prop-types */
import React, { Component } from 'react';
import { ComboBox, DropdownSkeleton } from 'carbon-components-react';
import PropTypes from 'prop-types';
import AuditRepository from '../../../helpers/api/AuditRepository';

export default class AuditPlanStatusComboBox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      items: [],
    };
    this.onChange = this.onChange.bind(this);
    this.repository = new AuditRepository();
  }

  async componentDidMount() {
    this.setState({ loading: true });
    const items = (await this.getItems());
    this.setState({ items, loading: false });
  }

  onChange = (selectedItem) => {
    const item = selectedItem ? selectedItem.selectedItem : null;
    this.props.onChange(item);
  };

  getItems = async () => {
    let items = [];

    try {
      items = await this.repository.getStatuses();
    } catch (error) {
      console.error(error);
      this.props.onError(error);
    }
    return items;
  };

  render() {
    return this.state.loading ? (
      <DropdownSkeleton />
    ) : (
      <ComboBox
        id="cmbStatus"
        disabled={this.state.items < 1 || this.props.disabled}
        placeholder="Choose a status"
        items={this.state.items}
        onChange={this.onChange}
        shouldFilterItem={({ item, inputValue }) =>
          item.planningName?.toLowerCase().includes(inputValue?.toLowerCase())
        }
        itemToString={(item) => (item ? item && item.planningName : '')}
        initialSelectedItem={this.props.initialSelectedItem}
      />
    );
  }
}

AuditPlanStatusComboBox.propTypes = {
  onChange: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired,
  initialSelectedItem: PropTypes.object,
  disabled: PropTypes.bool,
};
AuditPlanStatusComboBox.defaultProps = {
  initialSelectedItem: null,
  disabled: true,
};
